<zef-form
  [state]="state"
  (submit)="submit.emit(state)">

  <zui-user-data-fields
    [keyControlState]="state?.controls.key"
    [contentControlState]="state?.controls.content">
    <!-- handed straight through to the content field's own action corner;
         ngProjectAs is what makes the inner [contentAction] slot match it -->
    <ng-content select="[contentSlot]" ngProjectAs="[contentAction]"></ng-content>
  </zui-user-data-fields>

  @if (state?.controls.type.value === projectEnvTypes.User) {
    <zef-form-field appearance="slide-toggle">
      <mat-slide-toggle [ngrxFormControlState]="state?.controls.sensitive">
        Sensitive (secret variable)
      </mat-slide-toggle>
    </zef-form-field>
  }

  <ng-content></ng-content>

</zef-form>